<template>
  <div class="product-list">
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/gift_card/gift_card/add'">添加礼品卡</el-button>
      <!-- <el-button size="small" type="primary" @click="testPayment" icon="el-icon-plus" >测试支付</el-button> -->
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="name" label="礼品卡名称" width="120"></el-table-column>
<!--        <el-table-column prop="description" label="说明" width="200" show-overflow-tooltip></el-table-column>-->
        <el-table-column prop="price" label="价格" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column prop="value" label="价值" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.value }}
          </template>
        </el-table-column>
<!--        <el-table-column prop="expiration_days" label="有效期" width="120">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.expiration_days === 0 ? '永不结束' : scope.row.expiration_days + '天' }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="applicable_scope" label="适用范围" width="150">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.applicable_scope === 0 ? '所有服务和产品' : '指定服务' }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="status" label="状态" width="150">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-text="上架"
              inactive-text="下架"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template #default="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/gift_card/gift_card/edit'">编辑</el-button>
            <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/gift_card/gift_card/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>



  </div>
</template>

<script>
import GiftCardApi from '@/api/gift_card/gift_card.js';
import PaymentApi from "@/api/payment/payment";

export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      stripe:  null
    };
  },
  created() {
    /*获取列表*/
    this.getData();
    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      GiftCardApi.getList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /**
     * 跳转到添加页面
     */
    addClick() {
      this.$router.push('/gift_card/gift_card/add');
    },
    /**
     * 跳转到编辑页面
     * @param {Object} item
     */
    editClick(item) {
      this.$router.push({
        path: '/gift_card/gift_card/edit',
        query: { id: item.id }
      });
    },
    /**
     * 删除
     * @param {Object} row
     */
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该礼品卡, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        GiftCardApi.del({id: row.id }, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              self.getData();
            }
          }).catch(error => {
            self.loading = false;
          });
      }).catch(() => {
        self.loading = false;
      });
    },
    /**
     * 修改状态
     * @param {Object} row
     */
    changeStatus(row) {
      let self = this;
      self.loading = true;
      GiftCardApi.status({id: row.id, status: row.status}, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '状态修改成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
          // 恢复原状态
          row.status = row.status === 1 ? 0 : 1;
        });
    },

    /**
     * 每页多少条
     * @param {number} val
     */
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /**
     * 翻页
     * @param {number} val
     */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },
    async testPayment() {
      try {
        console.log('开始创建支付会话...');
        const response = await PaymentApi.createCheckoutSessionTest({}, true);
        console.log('createCheckoutSessionTest', response);

        if (response && response.code === 1) {
          console.log('跳转到 Stripe 支付页面...');
          const result = await this.stripe.redirectToCheckout({
            sessionId: response.data,
          });

          if (result.error) {
            this.$message.error('支付跳转失败: ' + result.error.message);
          }
        } else {
          this.$message.error('支付会话创建失败');
        }
      } catch (error) {
        console.error('支付测试失败:', error);
        this.$message.error('支付测试失败: ' + (error.message || error));
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/gift_card/gift_card/index.vue